// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsPlpClaimSumbitClaimRequestModel {
    static getAttributeTypeMap() {
        return ScriptsPlpClaimSumbitClaimRequestModel.attributeTypeMap;
    }
}
ScriptsPlpClaimSumbitClaimRequestModel.discriminator = undefined;
ScriptsPlpClaimSumbitClaimRequestModel.additionalProperties = false;
ScriptsPlpClaimSumbitClaimRequestModel.attributeTypeMap = [
    {
        "name": "docType",
        "baseName": "docType",
        "type": "number"
    },
    {
        "name": "files",
        "baseName": "files",
        "type": ""
    },
];
//# sourceMappingURL=scriptsPlpClaimSumbitClaimRequestModel.js.map